import React from 'react';

const NotFound = React.memo(() => {
    return (
        <div>Page not found!!</div>
    );
});

export default NotFound;